<template>
  <div class="asc-grid--date-selector">
    <asc-autocomplete-selector
      v-model="currentDaySelected"
      :items="daySelector"
      placeholder="Select number of days"
      label="Date Range"
      no-array
      no-search-input
      no-label
      no-tooltip
      dense
      drop-down-size-matches
      :min-width="120"
      :sort-items="false"
    ></asc-autocomplete-selector>
  </div>
</template>

<script>
import AscAutocompleteSelector from './AscAutocompleteSelector'
import { AscRangeDatePickerMixin } from '@/components/mixins'
import {
  getReportListMinDateGivenOffset,
  getReportListMaxDate,
} from '@/utilities/dates'

export default {
  name: 'AscGridDatePickerButton',

  components: {
    AscAutocompleteSelector,
  },

  mixins: [AscRangeDatePickerMixin],

  data() {
    return {
      currentDaySelected: this.daySelected,
      daySelector: [
        { value: 7, text: 'Last 7 days' },
        { value: 14, text: 'Last 14 days' },
        { value: 30, text: 'Last 30 days' },
        { value: 60, text: 'Last 60 days' },
        { value: 90, text: 'Last 90 days' },
        { value: 180, text: 'Last 180 days' },
      ],
    }
  },

  watch: {
    currentDaySelected(newValue) {
      const dates = {
        daySelected: newValue,
        startDate: getReportListMinDateGivenOffset(newValue),
        endDate: getReportListMaxDate(),
      }
      this.onDateChange(dates)
    },
  },
}
</script>

<style lang="scss">
.asc-grid--date-selector {
  margin-bottom: 8px;
}
</style>
